'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.hoursSince;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/hoursSince.js
// module id = 194
// module chunks = 1